const NETWORK_FAILED_ERROR = 'Network request failed'

export const isOfflineError = (error: Error): boolean => error.message === NETWORK_FAILED_ERROR
